import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import ReactTooltip           from 'react-tooltip';
import { Link }                from 'react-router-dom';
import QuestaoList            from './desafios_quiz_list';
import { GetMissaoQuestao,
         GetTipoAtividade }   from '../../../../actions/atividadesAction';
import { SetError }           from '../../../../actions/notificacaoAction';
import FlashCarregando        from '../../../../container/FlashCarregando';
import { GetListaMenuTopo,
        GetListaSubMenuTopo,
         ActionModal}         from '../../../../actions/scopoAction';

class QuizQuestao extends Component {

    constructor(props){
        super(props);
        this.state = {
            load   : false,
            que_id : this.props.match.params.id,
            tipo   :  "Carregando..."
        }
    }
    
    componentWillMount() {
      
        this.props.GetMissaoQuestao(this.state.que_id).then((response) => {
           this.setState({load:true,tipo: `- ${this.props.GetTipoAtividade(this.props.tipo)}`}) 
        }).catch((error)=>{
          this.props.SetError(500);
        });

        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:this.props.menu.desafios.nomeModulo,link:this.props.menu.desafios.home},
            {action:false,nome:this.props.menu.desafios.jogo.jogo3},
           ]);

        this.props.GetListaSubMenuTopo([]);
    }

    render() {
       
        return (

                <div>
                    <div className="container-bg">
                      
                    <div className="titulo-pages topo_conteudo">
                    <a className="titulo" data-for='titulo'  data-tip>{this.props.titulo}</a>
                    <ReactTooltip  id="titulo" type="dark" effect='solid'>{this.props.turma} / {this.props.disciplina}</ReactTooltip>
                    <div className="pull-right">
                       <Link to={`${this.props.menu.desafios.desafioquizaction}/${this.state.que_id}/novo`} className="btn btn-primary pull-right">Cadastrar</Link>
                    </div>
                    </div>
                    {!this.state.load ? <FlashCarregando/> : <QuestaoList que_id={this.state.que_id}/>}
                    </div>
                </div>
       
        );
    }
}
function mapStateToProps(state){

    return {
        menu         : state.configReducer.menu,
        tipo         : state.atividadesReducer.tipo,
        actionModal  : state.scopoReducer.actionModal,
        turma        : state.atividadesReducer.turma,
        titulo       : state.atividadesReducer.titulo,
        disciplina   : state.atividadesReducer.disciplina,
        all_questao : state.atividadesReducer.fetch_all_questao
    }
}
export default connect(mapStateToProps,{
                                        GetMissaoQuestao,
                                        GetTipoAtividade,
                                        GetListaMenuTopo,
                                        GetListaSubMenuTopo,
                                        ActionModal,
                                        SetError})(QuizQuestao);



// WEBPACK FOOTER //
// ./src/components/professor/desafios/quiz/desafios_quiz.js